var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuiz = function SvgQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.006 2.299a5.287 5.287 0 0 1 2.514-.916V.5a.5.5 0 0 1 1 0v.885c.17.016.341.04.509.073a1 1 0 0 1-.378 1.964 3.383 3.383 0 0 0-.631-.062A3.328 3.328 0 0 0 2.7 6.68 3.321 3.321 0 0 0 6.02 10a3.307 3.307 0 0 0 3.258-2.687 1 1 0 0 1 1.964.374A5.307 5.307 0 0 1 6.02 12 5.321 5.321 0 0 1 .7 6.68c0-1.454.587-2.774 1.537-3.736L1.5 2.207l-.646.647a.5.5 0 1 1-.708-.708l2-2a.5.5 0 1 1 .708.708l-.647.646.799.799zm3.368 5.415a.5.5 0 0 1-.708 0l-1.36-1.36a.5.5 0 1 1 .708-.708L6.02 6.653l4.646-4.647a.5.5 0 0 1 .708.708l-5 5z",
    fill: "#E6E6E6"
  })));
};

export default SvgQuiz;